import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { User, UserService } from '../services/user.service';
import { EditUserComponent } from './edit-user/edit-user.component';

@Component({
    imports: [MatTableModule, MatButtonModule, MatDialogModule],
    selector: 'app-user-management',
    template: `
        <div class="user-management-container">
            <div class="d-flex align-items-center mb-4">
                <h4 class="flex-grow-1 mb-0">User Management</h4>
            </div>
            <table mat-table [dataSource]="users" class="mat-elevation-z8">
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef>Email</th>
                    <td mat-cell *matCellDef="let user">{{ user.email }}</td>
                </ng-container>

                <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef>Role</th>
                    <td mat-cell *matCellDef="let user">{{ user.role }}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let user">
                        <button mat-button color="primary" (click)="editUser(user)">Edit</button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['email', 'role', 'actions']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['email', 'role', 'actions']"></tr>
            </table>
        </div>
    `,
    styles: [
        `
            table {
                width: 100%;
                margin-top: 20px;
            }
        `,
    ],
})
export class UserManagementComponent implements OnInit {
    users: User[] = [];
    dialog = inject(MatDialog);

    constructor(private userService: UserService) {}

    ngOnInit(): void {
        this.loadUsers();
    }

    loadUsers() {
        this.userService.getAllUsers().subscribe((users) => {
            this.users = users;
        });
    }

    editUser(user: User) {
        this.dialog.open<EditUserComponent, User>(EditUserComponent, {
            data: user,
        });
    }
}
